import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoProductosExistencias from '../../catalogos/catalogoProductosExistencias';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';

export const ModalVentasxProductos = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtCodigo = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtPorProduct = useRef();
  const txtNombreProducto = useRef();
  const txtTodosProduct = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtNombreAlmacen = useRef();
  const txtCodigoAlmacen = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtCbmrif = useRef();

  const [inputalmacen, setInputalmacen] = useState('');
  const [valalmacen, setValalmacen] = useState(null);
  const [valproducto, setValproducto] = useState(null);
  const [inputproducto, setInputproducto] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [numnota, setNumNota] = useState('');
  const [idclient, setIdclient] = useState('');
  const [vinpurt, setVinput] = useState(true);
  const [valida2, setValida2] = useState(0);
  const [activate, setActivate] = useState(false);
  const [idproduct, setIdproduct] = useState('');
  const [estatus, setEstatus] = useState('');
  const [valida, setValida] = useState(0);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });


  const blanquear = () => {
    setActivate(false);
    setInputalmacen('');
    setParafecha('');
    setDisponiblec('');
    setNumNota('');
    setInputproducto(0);
    setValida(0);
    setValida2(0);
    setIdclient('');
    setIdproduct('');
    setVinput(true);
    setMostrar1(false);
    setMostrar2(false);
    setEstatus("");
    setDesde('');
    setHasta('');
    setValalmacen(0);
    setValproducto(0);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {

      if (valida2 === 1 && txtTodosProduct.current.checked === false) {
        if (txtPorProduct.current.checked === true && txtCodigo.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
          txtCodigo.current.focus()
          sigue = false
        } else if (txtPorProduct.current.checked === false && txtTodosProduct.current.checked === false) {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Operación !', icono: 'informacion' });
          txtTodosProduct.current.focus()
          sigue = false
        } else {
          imprimirMovimientosVentas();
        }
      } else if (sigue === true) {

        imprimirMovimientosVentas();

      }

    }

  }

  const onChange = (e) => {

    if (e.target.name === 'desde') {
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde(e.target.value);
      }
    } else if (e.target.name === 'hasta') {
      setHasta(e.target.value);
    }

    if (e.target.name === 'inlineRadioOptionst') {

      if (e.target.value === '1') {
        setValproducto(0);
        setIdproduct(' and nt.idproducto > 0');
        txtCodigo.current.value = "";
        txtNombreProducto.current.value = "";
      } else {
        setValproducto(1);
      }

    }

    if (e.target.name === 'alamcen') {

      if (e.target.value === '1') {
        setValalmacen(0);
        setInputalmacen('');
        txtCodigoAlmacen.current.value = "";
        txtNombreAlmacen.current.value = "";
      } else {
        setValalmacen(1);
      }

    }

  }

  const imprimirMovimientosVentas = () => {

    var reporte = "";
    let desdec = "'" + moment(desde).format('DD-MM-YYYY') + "'";
    let hastac = "'" + moment(hasta).format('DD-MM-YYYY') + "'";
    let condicion;
    let oper = 0;
    let val = 0;

    if (inputalmacen !== '') {
      val = 1;
    } else {
      val = 0;
    }

    condicion = idproduct + inputalmacen;
    reporte = "ReporteVentasGananciasXProductoDos";
    oper = 2;

    window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&valida=" + oper + "&valalmacen=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

  }

  const handleAceptaProducto = (values) => {
    setMostrar1(false);
    setVinput(false);
    txtNombreProducto.current.value = values.nombrecorto;
    txtCodigo.current.value = values.codigo;
    setIdproduct(' and nt.idproducto = ' + values.idproducto);

  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarProducto = (id) => {
    let campos = "idproducto, nombre";
    let nomtab = "producto";
    let nomid = "codigo";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idproducto > 0) {
            setIdproduct(' and nt.idproducto = ' + response.data.idproducto);
            txtNombreProducto.current.value = response.data.nombre;
            setVinput(false);
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
            setVinput(true);
            txtCodigo.current.value = "";
            setIdproduct('');
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "notaentrega") {
          seleccionarProducto(event.target.value.toUpperCase());
        } /* else if (event.target.name === "nalmacen") {
          seleccionarAlmacen(event.target.value);
        } */
      }
    }
  };

  const handleAceptaAlmacen = (values) => {
    setMostrar2(false);
    txtNombreAlmacen.current.value = values.descripcion;
    txtCodigoAlmacen.current.value = values.idalmacen;
    setInputalmacen(' and n.idalmacen = ' + values.idalmacen);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 1) {
          txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
          txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
          setDesde(moment(fechasistema).format('YYYY-MM-DD'));
          setHasta(moment(fechasistema).format('YYYY-MM-DD'));
          setVinput(false);

        }


      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imprimir Movimientos de Ventas</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0 m-0'>

          <div className='col-12 row m-0 px-0 py-2'>

            <div className='col-pd-220 px-1 mb-2'>
              <div className="input-group input-group-sm">
                <label className="input-group-text" id="inputGroup-sizing-sm">DESDE:</label>
                <input type="date" disabled={props.ope === 0 ? true : false} onChange={onChange} ref={txtDesde} name='desde' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              </div>
            </div>

            <div className='col-pd-220 px-1 mb-2'>
              <div className="input-group input-group-sm">
                <label className="input-group-text" id="inputGroup-sizing-sm">HASTA:</label>
                <input type="date" disabled={props.ope === 0 ? true : false} onChange={onChange} ref={txtHasta} name='hasta' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              </div>
            </div>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.8rem' }}>PRODUCTOS:</legend>

              <div className='col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around'>
                <div className="form-check form-check-inline col-pd-120 mx-2 px-1">
                  <input className="form-check-input" type="radio" ref={txtTodosProduct} name="inlineRadioOptionst" onChange={onChange} id="inlineRadiot1" value="1" defaultChecked />
                  <label className="form-check-label" for="inlineRadiot1" style={{ fontSize: '0.8rem' }}>TODOS</label>
                </div>
                <div className="form-check form-check-inline col-pd-160 ml-1 px-1">
                  <input className="form-check-input" type="radio" ref={txtPorProduct} name="inlineRadioOptionst" onChange={onChange} id="inlineRadiot2" value="2" />
                  <label className="form-check-label" for="inlineRadiot2" style={{ fontSize: '0.8rem' }}>POR PRODUCTO</label>
                </div>
              </div>

              <div className='col-pd-300 px-0 mb-2'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO PRODUCTO: </label>
                  <input autoComplete='off' type="text" disabled={valproducto === 1 ? false : true} name="notaentrega" onKeyUp={handleInputNumeroChange} onBlur={handleInputNumeroChange} ref={txtCodigo} className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button type="button" onClick={() => setMostrar1(true)} disabled={valproducto === 1 ? false : true} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE PRODUCTO:</label>
                  <textarea type="text" disabled={true} ref={txtNombreProducto} name='nombre' style={{ height: idproduct !== '' ? '47px' : '30px' }} className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fw-bold" style={{ fontSize: '0.8rem' }}>ALMACEN:</legend>

              <div className='col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around'>

                <div className="form-check form-check-inline col-pd-120 mx-2 px-1">
                  <input className="form-check-input" name="alamcen" value="1" ref={txtTodosAlmacen} onChange={onChange} id="alamcen" type="radio" defaultChecked />
                  <label className="form-check-label" for="exampleRa1" style={{ fontSize: '0.8rem' }}>
                    TODOS
                  </label>
                </div>

                <div className="form-check form-check-inline col-pd-160 ml-1 px-1">
                  <input className="form-check-input" name="alamcen" value="2" ref={txtPorAlmacen} onChange={onChange} id="alamcen" type="radio" />
                  <label className="form-check-label" for="exampleRa2" style={{ fontSize: '0.8rem' }}>
                    POR ALMACEN
                  </label>
                </div>

              </div>

              {/* <input type='hidden' ref={txtIdProducto} /> */}

              <div className='col-pd-300 px-0 mb-2'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO ALMACEN:</label>
                  <input type="text" ref={txtCodigoAlmacen} disabled={true} /* onKeyUp={handleCliente} onBlur={handleCliente} */ className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={valalmacen === 1 ? false : true} type="button" onClick={() => setMostrar2(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE DEL ALMACEN:</label>
                  <input type="text" ref={txtNombreAlmacen} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </fieldset>

          </div>

        </div>


      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={vinpurt} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <CatalogoProductosExistencias
        show={mostrar1}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaProducto}
      />
      <CatalogoAlmacen
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/ventas/ImprimirMovimientosVentasP.js